import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function normalizeEscapedNewlines(value: string) {
  return value.replace(/\\r\\n/g, "\n").replace(/\\n/g, "\n");
}
